import type { PriceBook } from "@/entities/pricing/model/priceBook";
import type { SceneCard } from "@/entities/scene-card/model/types";

/**
 * 场景来源条的**规格 chip** —— 2026-07-28。
 *
 * ═══ 为什么要拆 chip ═══════════════════════════════════════════════════════
 * 原来这条只有一行拼起来的长句:「一次出三个比例,各平台同步发 · 3 张约 2,100 积分」。
 * 规格(几张 / 什么画幅 / 多少积分)是**可扫**的信息,拼成句子就只能从头读到尾。
 *
 * chip 从 `preset` 派生 —— 它是点卡时真正带进创建页的那份配置,和用户接下来看到的
 * 参数是同一个源。积分 chip 原样带上 `costLabel(book)` 的结果,**不在这里重算** ——
 * 卡面和来源条报不一样的数是最难查的那种缺陷(两处都"看起来对")。
 * 价目表没到货时 `costLabel` 返空串,这一条 chip 就不出(而不是出一个占位数字)。
 */
export function sceneOriginChips(card: SceneCard, book: PriceBook): string[] {
  const chips: string[] = [];
  const p = card.preset;

  if (p) {
    switch (p.kind) {
      case "poster_multiratio":
        // 「9:16 + 1:1 + 16:9」—— 比「一次三比例」具体:用户马上要在参数里看到同样这三个
        if (p.ratios.length) chips.push(p.ratios.join(" + "));
        break;
      case "poster_group":
        // 空模板(用户手填爆点)时不吹「N 个爆点」,那是还没发生的事
        if (p.groupPoints.length) chips.push(`${p.groupPoints.length} 个爆点`);
        break;
      case "poster_wide":
        chips.push("单帧宽图");
        break;
      default:
        break;
    }
  }

  const cost = card.costLabel(book);
  if (cost) chips.push(cost);
  return chips;
}
